/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Button, Row, Spin } from "antd";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { SHORTCUT_FILTER } from "constants/volSurface";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import React, { useContext, useEffect, useState } from "react";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import {
  BROKING_COMPANIES_END_POINT,
  fetchBrokingCompanies,
} from "api/volSurfaceApi";
import useFetchData from "hooks/useFetchData";
import { BROKING_COMPANIES_QUERY_KEY } from "constants/queries";
import { GlobalContext } from "contexts/GlobalContext";

export default function BrokingCompanies({
  dark_Theme,
  selectedFilters,
  setSelectedFilters,
}) {
  const { setRiskFree, setCostOfCarry, setAverage } =
    useVolSurfaceControlTable();

  const {
    globalState: { loginInfo },
  } = useContext(GlobalContext);

  const { data: brokingCompanies, isLoading } = useFetchData({
    url: BROKING_COMPANIES_END_POINT,
    queryKey: [BROKING_COMPANIES_QUERY_KEY, loginInfo?.user_id],
    enabled: !selectedFilters?.company_id,

    onSuccess: (res) => {
      if (selectedFilters?.company_id) return;
      setSelectedFilters((prev) => ({
        ...prev,
        company_id: res?.data?.data?.at(0)?.id,
      }));
    },
  });


  function onClickHandle(item) {
    if (item.id === selectedFilters?.company_id) return;
    setSelectedFilters((prev) => ({
      ...prev,
      company_id: item.id,
      product_id: null,
      shortcutFilter: null,
      comparison_surface_id: null,
      live_surface_id: null,
      risk_free: null,
      average: null,
      cost_of_carry: null,
      shortcut_name: null,
    }));
    setRiskFree(null);
    setAverage(null);
    setCostOfCarry(null);
    storeInLocalStorage(SHORTCUT_FILTER, JSON.stringify(item.company_id));
  }

  return (
    <Col span={24} style={{ marginBottom: "10px" }}>
      <Row className="bias-btn">
        <Col span={3}>Broking Companies:</Col>
        <Col span={21}>
          <Row gutter={12} style={{ rowGap: "12px" }}>
            {isLoading || !brokingCompanies?.data?.data ? (
              <Spin size="medium" className="mx-4" />
            ) : (
              <>
                {brokingCompanies?.data?.data?.map((item) => {
                  return (
                    <Col key={item.id}>
                      <Button
                        className={classNames({
                          "ant-btn-dark": dark_Theme,
                          "selected-button":
                            item?.id === selectedFilters?.company_id,
                        })}
                        key={item.id}
                        onClick={() => onClickHandle(item)}
                      >
                        {item.name}
                      </Button>
                    </Col>
                  );
                })}
              </>
            )}
          </Row>
        </Col>
      </Row>
    </Col>
  );
}
